import React, { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "./supabaseClient";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasToolAccess, setHasToolAccess] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session || null);
      setUser(data.session?.user || null);
      setLoading(false);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => {
      setSession(s);
      setUser(s?.user || null);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  useEffect(() => {
    const checkAccess = async () => {
      if (!user) { setHasToolAccess(false); return; }
      const { data, error } = await supabase
        .from("tool_access")
        .select("active")
        .eq("user_id", user.id)
        .maybeSingle();
      setHasToolAccess(!!data?.active && !error);
    };
    checkAccess();
  }, [user]);

  return (
    <AuthCtx.Provider value={{ session, user, loading, hasToolAccess }}>
      {children}
    </AuthCtx.Provider>
  );
}
